import { PageTitle } from '@dec/shared';
import { t } from 'i18next';
import { FileEarmarkText } from 'react-bootstrap-icons';

import { TaxReturnSummaryCard } from '../../../components/TaxReturnSummaryCard';
import { type TaxReturnSummary } from '../../../models/TaxReturn';

import { HeaderPreview } from './header';
import { TaxReturnBody } from './taxReturnBody';

interface TaxReturnContentProps {
  content: TaxReturnSummary;
}

export const TaxReturnContent = ({ content }: TaxReturnContentProps) => {
  return (
    <div className="print-only">
      <div className="d-print-none">
        <PageTitle
          title={t('config.taxReturn')}
          subtitle={t('taxreturn-report.title.page')}
          icon={FileEarmarkText}
        />
      </div>
      <HeaderPreview />
      <TaxReturnSummaryCard content={content} />
      <TaxReturnBody content={content} />
    </div>
  );
};
